import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CountryCityService } from '../country-city.service';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-add-country',
  templateUrl: './add-country.component.html',
  styleUrls: ['./add-country.component.scss']
})
export class AddCountryComponent implements OnInit {
  model: any = {};
  constructor(
    private router: Router,
    private toastr: ToastrService,
    private countryService: CountryCityService
  ) { }

  ngOnInit() {
  }
  onSubmit() {
    this.countryService.createCountry(this.model).subscribe((Data: any) => {
     this.toastr.success('Country added');
      if (!Data.id) {
        this.router.navigateByUrl('/country-list');
      }
      console.log('Country added', Data);

    });
      }

}
